import React, { createContext, useContext, useState } from 'react';


interface BranchInfoContextType {
  branchIds: Record<number, string>[];
  mainBranchIds: [number, number, number];
  setBranchIds: React.Dispatch<React.SetStateAction<Record<number, string>[]>>;
  setMainBranchId: React.Dispatch<React.SetStateAction<[number, number, number]>>;
}

const BranchContext = createContext<BranchInfoContextType | null>(null);

export const useBranchInfo = (): BranchInfoContextType => {
  const ctx = useContext(BranchContext);
  if (!ctx) {
    throw new Error('❗useBranchIds must be used within a BranchProvider');
  }
  return ctx;
};

export const BranchInfoProvider = ({ children }: { children: React.ReactNode }) => {
  const [branchIds, setBranchIds] = useState<Record<number, string>[]>([]);
  const [mainBranchIds, setMainBranchId] = useState<[number, number, number]>([0, 0, 0]);

  return (
    <BranchContext.Provider
      value={{ branchIds, mainBranchIds, setBranchIds, setMainBranchId }}
    >
      {children}
    </BranchContext.Provider>
  );
};
